/**
 * Login page
 */

import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Alert, Button } from '../components/ui.jsx';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-surface-subtle px-4 py-8">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-section bg-brand-blue text-sm font-bold text-white shadow-card">FA</div>
          <h1 className="text-3xl font-bold tracking-[-0.02em] text-text-primary">FACTRANS ATS</h1>
          <p className="mt-2 text-sm text-text-muted">Internal hiring workspace</p>
        </div>

        <section className="rounded-section border border-border-default bg-white p-6 shadow-card sm:p-8" aria-labelledby="login-heading">
          <div className="mb-6">
            <h2 id="login-heading" className="text-xl font-bold text-text-primary">Sign in</h2>
            <p className="mt-1 text-sm text-text-muted">Use your workspace account to review applicants and imports.</p>
          </div>

          {error && <Alert variant="danger" className="mb-4" role="alert">{error}</Alert>}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="login-email" className="mb-1 block text-sm font-semibold text-text-primary">
                Email address
              </label>
              <input
                id="login-email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                className="input"
                placeholder="you@company.com"
              />
            </div>

            <div>
              <label htmlFor="login-password" className="mb-1 block text-sm font-semibold text-text-primary">
                Password
              </label>
              <input
                id="login-password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                className="input"
                placeholder="••••••••"
              />
            </div>

            <Button type="submit" loading={loading} className="w-full">
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </section>

        <footer className="mt-6 text-center text-sm text-text-secondary">
          <p>hiring.factrans.com · Internal use only</p>
          <p className="mt-1 text-xs text-text-muted">© {new Date().getFullYear()} First Choice Ambulette</p>
        </footer>
      </div>
    </main>
  );
}
